









































































































































































































































































































































import Vue from 'vue';
import PropertyCheckbox from '../components/PropertyCheckbox.vue';
import PropertyInput from '../components/PropertyInput.vue';
import PropertySelect from '../components/PropertySelect.vue';

export default Vue.extend({
  name: 'Weapons',
  components: {
    PropertyCheckbox,
    PropertyInput,
    PropertySelect,
  },
  data: () => ({
    model: '',
    previewDialog: false,
  }),
  computed: {
    weaponType: function () {
      return this.$store.state.weaponType;
    },
    calledWeaponIcon: function () {
      return this.$store.state.calledWeaponIcon;
    },
    viewmodels: function () {
      return this.$store.state.viewmodels;
    },
    playermodels: function () {
      return this.$store.state.playermodels;
    },
    crosshair: function () {
      return this.$store.state.crosshair;
    },
    weaponSound: function () {
      return this.$store.state.weaponSound;
    },
    projectileTrailEffect: function () {
      return this.$store.state.projectileTrailEffect;
    },
    isBurst: function () {
      if (this.$store.state.weapon.burst_fire_count != '1') {
        return true;
      } else {
        return false;
      }
    },
    ammoType: function () {
      return this.$store.state.ammoType;
    },
    hasExtendedMag: function () {
      return this.$store.state.weapon.ammo_pool_type != 'shotgun';
    },
    hasRegenammo: function () {
      return this.$store.state.weapon.regen_ammo_refill_rate != '0';
    },
    viewkickPreset: function () {
      return this.$store.state.viewkickPreset;
    },
    weaponText: function () {
      return this.$store.state.weaponText;
    },
  },
  methods: {
    openPreviewDialog() {
      this.$store.dispatch('generationText');
      this.previewDialog = true;
    },
    copyText: function () {
      this.$store.dispatch('generationText');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.$store.state.weaponText);
      }
    },
    downloadText: function () {
      this.$store.dispatch('generationText');
      const blob = new Blob([this.$store.state.weaponText], {
        type: 'text/plain',
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'mp_weapon_' + this.$store.state.weapon.id + '.txt';
      link.click();
      URL.revokeObjectURL(link.href);
    },
    importText(e: any) {
      const files = e.target.files || e.dataTransfer.files
      const reader = new FileReader()
      reader.readAsText(files[0])
      reader.onload = () => {
        this.$store.dispatch('importText', reader.result);
      }
    },
  },
});
